import React from "react";
import { Navigate } from "react-router-dom";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import AuthLockScreen from "../pages/Authentication/AuthLockScreen";
import Dashboard from "../pages/Dashboard";
import Customers from "../pages/Customers";
import EntryForm from "../pages/EntryForm";
import BoxReport from "../pages/BoxReport";
import DepositEntryForm from "../pages/DepositEntryForm";
import CreditMaster from "../pages/CreditMaster";
import UdharReport from "../pages/UdharReport";
import JavadMel from "../pages/JavadMel";
import CreditDepositEntry from "../pages/CreditDepositEntry";
import AverageReport from "../pages/AverageReport";
import HisabBook from "../pages/HisabBook";
import StockReport from "../pages/StockReport";
import ItemMaster from "../pages/ItemMaster";
import PartyMaster from "../pages/PartyMaster";
import CreditUdhar from "../pages/CreditUdhar";
import PartyList from "../pages/PartyList";
import Party from "../pages/Party";
import KhatanoUtaro from "../pages/KhatanoUtaro";
import BackupRestore from "../pages/BackupRestore";
import CreditPankh from "../pages/CreditPankh";
import Bahar from "../pages/Bahar";
import UdharChithi from "../pages/UdharChithi";
import CreditUdharani from "../pages/CreditUdharani";
import WholeSaleBillList from "../pages/WholeSaleBillList"
import ReportForm from "../pages/ReportForm";
import CrateAccountReport from "../pages/AccountReport";
import CrateAccountEntryFull from "../pages/AccountEntry";
import TraderSaleEntry from "../pages/TraderSaleEntry";

const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/customers", component: <Customers /> },

  // Your new menu pages
  { path: "/entry-form", component: <EntryForm /> },
  { path: "/box-report", component: <BoxReport /> },
  { path: "/deposit-entry-form", component: <DepositEntryForm /> },
  { path: "/credit-master", component: <CreditMaster /> },
  { path: "/udhar-report", component: <UdharReport /> },
  { path: "/javad-mel", component: <JavadMel /> },
  { path: "/credit-deposit-entry", component: <CreditDepositEntry /> },
  { path: "/average-report", component: <AverageReport /> },
  { path: "/hisab-book", component: <HisabBook /> },
  { path: "/stock-report", component: <StockReport /> },
  { path: "/item-master", component: <ItemMaster /> },
  { path: "/party-master", component: <PartyMaster /> },
  { path: "/credit-udhar", component: <CreditUdhar /> },
  { path: "/party-list", component: <PartyList /> },
  { path: "/party", component: <Party /> },
  { path: "/account-statement", component: <KhatanoUtaro /> },
  { path: "/backup-restore", component: <BackupRestore /> },
  { path: "/credit-paper", component: <CreditPankh /> },
  { path: "/exit", component: <Bahar /> },
  { path: "/udhar-chithi", component: <UdharChithi /> },
  { path: "/credit-udharani", component: <CreditUdharani /> },
  { path: "/whole-sale-bill-list", component: <WholeSaleBillList /> },

  { path: "/", exact: true, component: <Navigate to="/dashboard" /> },
];

const publicRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },
  { path: "/lock-screen", component: <AuthLockScreen /> },

  //testing

  { path: "/dashboard", component: <Dashboard /> },
  { path: "/customers", component: <Customers /> },
  { path: "/entry-form", component: <EntryForm /> },
  { path: "/box-report", component: <BoxReport /> },
  { path: "/deposit-entry-form", component: <DepositEntryForm /> },
  { path: "/credit-master", component: <CreditMaster /> },
  { path: "/udhar-report", component: <UdharReport /> },
  { path: "/javad-mel", component: <JavadMel /> },
  { path: "/credit-deposit-entry", component: <CreditDepositEntry /> },
  { path: "/average-report", component: <AverageReport /> },
  { path: "/hisab-book", component: <HisabBook /> },
  { path: "/stock-report", component: <StockReport /> },
  { path: "/item-master", component: <ItemMaster /> },
  { path: "/party-master", component: <PartyMaster /> },
  { path: "/credit-udhar", component: <CreditUdhar /> },
  { path: "/party-list", component: <PartyList /> },
  { path: "/party", component: <Party /> },
  { path: "/account-statement", component: <KhatanoUtaro /> },
  { path: "/backup-restore", component: <BackupRestore /> },
  { path: "/credit-paper", component: <CreditPankh /> },
  { path: "/exit", component: <Bahar /> },
  { path: "/udhar-chithi", component: <UdharChithi /> },
  { path: "/credit-udharani", component: <CreditUdharani /> },
  { path: "/whole-sale-bill-list", component: <WholeSaleBillList /> },
  { path: "/report-form", component: <ReportForm /> },
  { path: "/account-report", component: <CrateAccountReport /> },
  { path: "/account-entry", component: <CrateAccountEntryFull /> },
  { path: "/trader-sale-entry", component: <TraderSaleEntry /> }

  // { path: "/maintenance", component: <Maintenance /> },
];

export { authProtectedRoutes, publicRoutes };
